module.exports = __webpack_public_path__ + "img/icon(1).cdd1eecf.png";